import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext'; // Importa il contesto del tema

const LanguageSelector = ({ compact = false }) => {
  const { i18n } = useTranslation();
  const { isDark } = useTheme(); // Ottieni lo stato del tema
  const currentLanguage = i18n.language;
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setIsOpen(false);
    // Salva la preferenza nel localStorage
    localStorage.setItem('preferred_language', lng);
  };

  // Gestisce il click all'esterno per chiudere il dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`p-2 rounded-full transition-colors flex items-center ${compact ? 'justify-center' : ''} ${
          isDark 
            ? 'hover:bg-gray-700 bg-gray-800/60' 
            : 'hover:bg-gray-200 bg-gray-100/60'
        }`}
        aria-label="Change language"
        title={compact ? `${currentLanguage === 'it' ? 'Italiano' : 'English'}` : undefined}
      >
        <Globe className={`h-5 w-5 flex-shrink-0 ${
          isDark 
            ? 'text-indigo-300 group-hover:text-indigo-200' 
            : 'text-indigo-600 group-hover:text-indigo-700'
        }`} />
        {!compact && (
          <span className={`ml-1 text-xs uppercase font-medium ${
            isDark 
              ? 'text-gray-200' 
              : 'text-gray-700'
          }`}>{currentLanguage}</span>
        )}
      </button>
      {isOpen && (
        <div className={`absolute left-0 bottom-full mb-2 w-36 rounded-md shadow-lg py-1 z-50 border ${
          isDark 
            ? 'bg-gray-800 border-gray-700' 
            : 'bg-white border-gray-200'
        }`}>
          <button
            onClick={() => changeLanguage('it')}
            className={`block w-full text-left px-4 py-2 text-sm ${
              currentLanguage === 'it' 
                ? isDark 
                  ? 'bg-indigo-900/30 text-indigo-300' 
                  : 'bg-indigo-50 text-indigo-600'
                : isDark 
                  ? 'text-gray-300 hover:bg-gray-700' 
                  : 'text-gray-700 hover:bg-gray-100'
            }`}
          >
            🇮🇹 Italiano
          </button>
          <button
            onClick={() => changeLanguage('en')}
            className={`block w-full text-left px-4 py-2 text-sm ${
              currentLanguage === 'en' 
                ? isDark 
                  ? 'bg-indigo-900/30 text-indigo-300' 
                  : 'bg-indigo-50 text-indigo-600'
                : isDark 
                  ? 'text-gray-300 hover:bg-gray-700' 
                  : 'text-gray-700 hover:bg-gray-100'
            }`}
          >
            🇬🇧 English
          </button>
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;